import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '~/src/layouts/component-layout';
import { Text, Note } from '@primer/react';
import { Link as GatsbyLink } from 'gatsby';
import { AccessibilityLink } from '~/src/components/accessibility-link';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <h2>{`Usage`}</h2>
    <p>{`The tooltip component adds a tooltip to add context to interactive elements on the page.`}</p>
    <img width="960" role="presentation" src="https://github.com/primer/design/assets/586552/787873b7-d496-454c-b669-0c2400ef503f" alt="three examples of tooltips on interactive elements" />
    <h2>{`Accessibility`}</h2>
    <Note variant="danger" mdxType="Note">
  <Text sx={{
        display: 'block',
        fontWeight: 'bold',
        mb: 2
      }} mdxType="Text">⚠️ Usage Warning ⚠️</Text>
  <Text mdxType="Text">Tooltips as a UI pattern should be our last resort for conveying information because it is hidden by default and often with zero or little visual indicator of its existence.</Text>
    </Note>
    <p>{`Before adding a tooltip, please consider: Is this information essential and necessary? Can the UI be made clearer? Can the information be shown on the page by default? See Tooltip alternatives for more accessible alternatives.`}</p>
    <p>{`We use aria-label for tooltip contents. However, aria-label replaces the text content of an element in screen readers, so only use Tooltip on elements with no existing text content.`}</p>
    <p>{`A tooltip may only be used on an element that is interactive such as a button or a link. Even if an element is focusable, a tooltip may only be used if the element does something when it's clicked.`}</p>
    <h3>{`Tooltip alternatives`}</h3>
    <p>{`Most UI cases don't call for tooltips. Learn some `}<a parentName="p" {...{
        "href": "/../guides/accessibility/tooltip-alternatives"
      }}>{`alternative methods to use in place of tooltips`}</a>{`.`}</p>
    <h3>{`Known accessibility issues`}</h3>
 <AccessibilityLink label="tooltip" mdxType="AccessibilityLink" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      